import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateStoreGeofence(payload) {
    return requestPost(apiPath.STORE_GEOFENCE.path, payload)
  },

  GetOneStoreGeofence(storeGeofenceID) {
    return requestGet(`${apiPath.STORE_GEOFENCE.path}/${storeGeofenceID}`)
  },

  GetAllStoreGeofence(paging, sorting, filtering) {
    return requestGet(apiPath.STORE_GEOFENCE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_type: filtering.type,
      f_sequence: filtering.sequence,
      f_latitude: filtering.latitude,
      f_longitude: filtering.longitude
    })
  },

  UpdateStoreGeofence(storeGeofenceID, payload) {
    return requestPut(
      `${apiPath.STORE_GEOFENCE.path}/${storeGeofenceID}`,
      payload
    )
  },

  DeleteStoreGeofence(storeGeofenceID) {
    return requestDelete(`${apiPath.STORE_GEOFENCE.path}/${storeGeofenceID}`)
  },

  GetStoreGeofence(outletCode, page, size) {
    return requestGet(apiPath.GET_STORE_GEOFENCE.path, {
      page: page,
      size: size,
      f_outletCode: outletCode
    })
  },

  NearestStore(lat, lng) {
    return requestGet(apiPath.NEARST_STORE.path, {
      lat: lat,
      lng: lng
    })
  }
}

export default api
